import { Outlet } from "react-router-dom";
import Faq from "../../components/home/Faq";
import { useTranslation } from "react-i18next";
import Steps from "../../components/home/Steps";
import Member from "../../components/home/Member";
import { useState } from "react";
import Register from "./Register";
import Reasons from "../../components/home/Reasons";
import Footer from "../../layout/Footer";
import Competitors from "./Competitors";
import Header from "./Header";
const HomeLayout = ({ handleLogin }) => {
  const { t } = useTranslation();
 
   const [show, setShow] = useState(false);
   const [activeForm, setActiveForm] = useState("in"); // "in" or "up"
 
   const openModal = (formType = "in") => {
     setActiveForm(formType);
     setShow(true);
   };
        
  const outletContextValue = { };

  
  return (
    <section className="w-100 position-relative">
      <Header openModal={openModal} />
      <div className="" style={{ minHeight: "500px"}}>
 
        <Outlet context={outletContextValue} />
   
      
      </div>
      <Footer t={t} />
      <Register
          show={show}
          setShow={setShow}
          handleLogin={handleLogin}
          activeForm={activeForm}
          setActiveForm={setActiveForm}
        />
    </section>
  );
  
};

export default HomeLayout;
